import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Button,
  Paper,
  Typography
} from '@mui/material';
import {
  ArrowBack as BackIcon
} from '@mui/icons-material';
import AdditionalDocument from '../components/common/AdditionalDocument';
import PageTitle from '../components/PageTitle';

/**
 * Additional Documents Page Wrapper
 * This component extracts URL parameters and renders the AdditionalDocument component
 */
const AdditionalDocumentsPage = () => {
  const { appId, orgId } = useParams();
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Navigate back to the previous page or to a default page
    navigate(-1);
  };

  const handleDocumentSaved = (document) => {
    console.log('Document saved successfully:', document);
    // You can add additional logic here if needed
  };

  const handleDocumentDeleted = (document) => {
    console.log('Document deleted successfully:', document);
    // You can add additional logic here if needed
  };

  return (
    <>
    <PageTitle title="NABL | Additional Documents" />
    <Box sx={{ 
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      py: 3,
      mt: 5,
    }}>
      <Container maxWidth="xl">
        {/* Additional Documents Component */}
        <AdditionalDocument
          orgId={orgId}
          appId={appId}
          title="Additional Documents Management"
          subtitle="Upload and manage additional documents for your application"
          showExisting={true}
          onDocumentSaved={handleDocumentSaved}
          onDocumentDeleted={handleDocumentDeleted}
          onBack={handleGoBack}
          showBackButton={true}
          readOnly={false}
        />
      </Container>
    </Box>
    </>
  );
};

export default AdditionalDocumentsPage;